import { isAddressInCidrRange } from '../../../is-address-in-cidr-range/is-address-in-cidr-range';
import { isAddressInContiguousRange } from '../../../is-address-in-contiguous-range/is-address-in-contiguous-range';
import { isPortInPortList } from '../../../is-port-in-port-list/is-port-in-port-list';
import type { ScanExclusionType } from '../../add-ip-range-form/add-ip-range-form';
import { ScanExclusionColumns } from '../table-filter-row/table-filter-row';

export const getFilteredRows = (
  row: ScanExclusionType,
  query: string,
  type: ScanExclusionColumns,
) => {
  if (!query) return true;

  const { ipRange, ports } = row;

  const rangeFiltering = (query: string, ipRange: string) => {
    return ipRange.includes('-')
      ? isAddressInContiguousRange(query, ipRange)
      : ipRange.includes('/')
        ? isAddressInCidrRange(query, ipRange)
        : false;
  };

  switch (type) {
    case ScanExclusionColumns.IP_RANGE: {
      return ipRange.includes(query) || rangeFiltering(query, ipRange);
    }
    case ScanExclusionColumns.PORTS: {
      return isPortInPortList(query, ports);
    }
    default:
      return false;
  }
};
